import React, { useState, useEffect } from "react";

import { FormControlLabel, Switch } from "@mui/material";
import Feedback from "./Feedback";
import Information from "./Information";
import UserMenu from "./UserMenu";
import { useNavigate } from "react-router-dom";

function Header({
  activeTab,
  handleTabChange,
  toggleMenu,
  isMenuOpen,
  handleLogout,
  geocoderContainerRef,
  showSearch = false,
  showFavorites = false,
  showLinks = false,
  handleUpgrade,
  isSubscribed = false,
}) {
  const navigate = useNavigate();
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [showNotificationModal, setShowNotificationModal] = useState(false);
    const storedName = localStorage.getItem('name') || 'User';
  const storedEmail = localStorage.getItem('email') || 'unknown';
  // Upgrade button handler
  const handleUpgrade1 = () => {
    // navigate('/stripe-integration');
    navigate("/pricing");
    // navigate('/payment');
    // navigate('/stripe');

    // navigate('/premium');
  };
  useEffect(() => {
    if (activeTab === "all" && geocoderContainerRef.current) {
      if (
        geocoderContainerRef.current.childNodes.length === 0 &&
        window.geocoderInstance
      ) {
        geocoderContainerRef.current.appendChild(
          window.geocoderInstance.onAdd(window.initializedMap)
        );
      }
    }
  }, [activeTab, geocoderContainerRef]);

  return (
    <div className="headerTop">
      <div className="dflex subHeaderTop">
        {/* FlowLogic Icon */}
        <a href="/dashboard">  
         {/* <a href="/points"> */}
          <img
            className="logo"
            src="/assets/Flowlogic-Logo.svg"
            alt="FlowLogic Icon"
          />
        </a>

        <div className="headerRightOuter">
             <div class="headerMiddleOuter">
        {showFavorites && (
          <a
            onClick={() =>
              handleTabChange(activeTab === "favorites" ? "all" : "favorites")
            }
            className={`tab-button favorites ${
              activeTab === "favorites" ? "favorites-active" : ""
            }`}
          >
            <img
              src={
                activeTab === "favorites"
                  ? "/assets/favorite.svg" // active icon
                  : "/assets/heart.svg" // inactive icon
              }
              alt="My favorites"
            />{" "}
            Favorites
          </a>
        )}

        <div className="iconGroup">
          {!isSubscribed && (
            <button className="upgrade-btn" onClick={handleUpgrade1}>
              Upgrade
            </button>
          )}
        </div>

        {showLinks && (
          <div className="iconGroup">
            <Information /> {/* Information details */}
            <Feedback /> {/* Feedback form */}
          </div>
        )}

     <div className="profilePic">
              <div 
          style={{
            width: 40,
            height: 40,
            borderRadius: '50%',
            backgroundColor: '#1C8F7D',
            color: 'white',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontWeight: 'bold',
            userSelect: 'none',
            cursor: 'pointer'
          }}
          aria-label="User Initial"
          title={storedEmail}
        >
          {storedName.charAt(0).toUpperCase()}
        </div>
        
      </div>

      </div>
          <UserMenu
            isMenuOpen={isMenuOpen}
            toggleMenu={toggleMenu}
            handleLogout={handleLogout}
          />
        </div>
      </div>
   
      {/* Search Box - Only if showSearch is true */}

      {showSearch && activeTab !== "favorites" && (
      // {showSearch &&(
        <div className="search">
          <div ref={geocoderContainerRef} className="geoCodeSerach"></div>
        </div>
      )}
    </div>
  );
}

export default Header;
